import Vue, {DirectiveOptions} from 'vue'

import 'normalize.css'
import ElementUI from 'element-ui'
import SvgIcon from 'vue-svgicon'

import '@/styles/element-variables.scss'
import '@/styles/index.scss'
import '@/styles/base_helpers.scss'
import '@/styles/base_flex.scss'

import App from '@/App.vue'
import store from '@/store'
import {AppModule} from '@/store/modules/app'
import router from '@/router'
import i18n from '@/lang'
import '@/icons/components'
import '@/permission'
import * as directives from '@/directives'
import * as filters from '@/filters'


import io from 'socket.io-client';
import VueSocketIO from 'vue-socket.io';

import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.material.purple.light.compact.css'

import Highcharts from 'highcharts';
import Stock from 'highcharts/modules/stock';
import HighchartsVue from 'highcharts-vue'

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import SingletonService from "@/services/singleton-service";

import VueSanitize from 'vue-sanitize-directive';
import VueNativeSock from 'vue-native-websocket';

Vue.use(VueSanitize);


Vue.use(VueToast, {
  // One of the options
  position: 'top',
  duration: 5000
})

Stock(Highcharts);
Vue.use(HighchartsVue);

Vue.use(ElementUI, {
  size: AppModule.size, // Set element-ui default size
  i18n: (key: string, value: string) => i18n.t(key, value)
});

// @ts-ignore
let conn_str: string = config.VUE_APP_SOCKET_API; // global var from config
console.log(conn_str)

if (location.protocol !== 'https:') {
  console.log(location.protocol)
  conn_str = conn_str.replace('wss://', 'ws://');
} else {
  console.log(location.protocol)
  conn_str = conn_str.replace('ws://', 'wss://');
}

console.log(conn_str)

Vue.use(VueNativeSock, conn_str, {
  store: store,
  format: 'json',
  reconnection: true,
  reconnectionDelay: 1000,
});


Vue.use(SvgIcon, {
  tagName: 'svg-icon',
  defaultWidth: '1em',
  defaultHeight: '1em'
})

// Register global directives
Vue.use(directives.default)

// Register global filter functions
Object.keys(filters).forEach(key => {
  Vue.filter(key, (filters as { [key: string]: Function })[key])
})

Vue.config.productionTip = false

const cacheResetKey = 'deployResetCache20230206';
if (!localStorage.getItem(cacheResetKey)) {
  localStorage.clear();
  localStorage.setItem(cacheResetKey, 'ok')
}

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),

}).$mount('#app')
